import { Parser } from 'm3u8-parser';
import { f as fetchText } from './fetch.js';
import { t as toError } from './error.js';

class DecodeError extends Error {
  constructor(message, cause) {
    super(message);
    this.cause = cause;
    Object.setPrototypeOf(this, DecodeError.prototype);
    this.name = 'DecodeError';
  }

}

class NetworkError extends Error {
  constructor(message, cause) {
    super(message);
    this.cause = cause;
    Object.setPrototypeOf(this, NetworkError.prototype);
    this.name = 'NetworkError';
  }

}

/**
 * Selected information from an HLS media playlist.
 */

/**
 * Fetch and parse an HLS media playlist.
 */
async function loadHlsMediaPlaylist(url, options) {
  let data;

  try {
    data = await fetchText(url, options);
  } catch (e) {
    const error = toError(e);

    if (error.name === 'AbortError') {
      throw error;
    }

    throw new NetworkError(`Failed to fetch media playlist: ${url}`, error);
  }

  return parseHlsMediaPlaylist(data);
}
/**
 * Parse the raw text data of an HLS media playlist.
 */

function parseHlsMediaPlaylist(data) {
  var _manifest$totalDurati;

  const parser = new Parser();

  try {
    parser.push(data);
    parser.end();
  } catch (e) {
    throw new DecodeError('Failed to parse media playlist.', toError(e));
  }

  const manifest = parser.manifest;
  const fixedEnd = manifest.endList === true || manifest.playlistType === 'VOD';
  const fixedStart = manifest.playlistType === 'VOD' || manifest.playlistType === 'EVENT';
  const programDateTime = manifest.dateTimeObject;
  const playlistDuration = (_manifest$totalDurati = manifest.totalDuration) != null ? _manifest$totalDurati : manifest.segments.reduce((total, segment) => total + segment.duration, 0);
  const averageSegmentDuration = manifest.segments.length === 0 ? manifest.targetDuration : Math.round(playlistDuration / manifest.segments.length);

  if (averageSegmentDuration === undefined) {
    throw new DecodeError('Media playlist is missing required tag EXT-X-TARGETDURATION.');
  }

  return {
    averageSegmentDuration,
    fixedEnd,
    fixedStart,
    playlistDuration,
    programDateTime
  };
}

export { DecodeError as D, NetworkError as N, loadHlsMediaPlaylist as l };
